<template>
  <Teleport
    v-if="isModalOpen"
    to="#global-modals-container">
    <div
      v-show="isTopModal"
      class="fixed flex h-full justify-center left-0 max-h-[100%] top-0 w-screen z-50"
      :class="{'items-center': centered}"
      data-test="modal-wrapper"
      tabindex="-1">
      <div
        v-show="isTopModal"
        class="bg-black fixed flex h-screen justify-center left-0 opacity-50 top-0 w-screen"
        data-test="modal-backdrop"
        @click="handleClose" />
      <div
        v-show="isTopModal"
        ref="modalRef"
        :aria-describedby="ariaDescribedBy"
        :aria-labelledby="ariaLabelledBy"
        aria-modal="true"
        :class="cn('fixed grow h-full max-w-2xl md:h-auto p-4 w-full', containerClass)"
        data-test="modal-container"
        role="dialog">
        <div
          class="bg-white modal-content p-3 px-3.5 rounded-lg shadow-sm"
          :class="contentClass"
          :data-test="dataTest">
          <slot />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import {cn} from '@myparcel-frontend/utils';
import {watch} from 'vue';
import {useModal} from '@/composables/useModal';
import {useModalFocus} from '@/composables/useModalFocus';

// TODO: defineProps destructuring FE-1574
const props = defineProps<{
  name: string;
  centered?: boolean;
  containerClass?: string;
  contentClass?: string;
  ariaLabelledBy?: string;
  ariaDescribedBy?: string;
  dataTest?: string;
  onClose?: () => void;
}>();

const {isModalOpen, isTopModal} = useModal(props.name);
const {modalRef} = useModalFocus(props.name);

const handleClose = (): void => {
  if (props.onClose) {
    props.onClose();
  }
};

const closeOnEscape = (event: KeyboardEvent) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};

watch([isModalOpen, isTopModal], ([isOpen, isTop]) => {
  if (isOpen && isTop) {
    document.addEventListener('keyup', closeOnEscape);
  } else {
    document.removeEventListener('keyup', closeOnEscape);
  }
});
</script>
